// ENG-8000: a dashboard/API-issued restart tears down an agent's live session so
// the next ensure*Runtime cycle respawns it. The teardown differs by framework,
// and BOTH restart lanes - the fast restart-doorbell lane (handleRestartDoorbell)
// and the slow-poll restart consumer (pollCycle) - branch on this predicate:
//
//   - opencode runs a headless `opencode serve` under its own tmux namespace
//     (`agt-oc-<code>`), torn down via stopOpencodeSession. That teardown also
//     flips the in-memory session to 'stopped', so startOpencodeSession's
//     already-'running' short-circuit cannot wedge the respawn (a raw external
//     `tmux kill` leaves the map at 'running' and the serve never respawns - the
//     nora recovery note on ENG-8000).
//   - claude-code runs a `agt-<code>` tmux pane, torn down via a tmux kill plus
//     the persistent-session teardown (stopPersistentSessionAndForgetMcpBaseline).
//
// Before this predicate both lanes only ever killed `agt-<code>`, which misses an
// opencode serve entirely: the serve stays healthy, ensureOpencodeRuntime
// early-returns 'healthy', and the restart is a silent no-op (yet still acked).
//
// Kept as a pure function so the branch is unit-testable without the
// manager-worker module graph. Any framework other than 'opencode' (including an
// absent value, which defaults to claude-code) uses the Claude pane teardown.

export function restartTargetsOpencodeServe(framework: string | null | undefined): boolean {
  return framework === 'opencode';
}
